import React, { Component } from "react";
import appleStoreBadge from "../assets/badges/apple-store-badge.svg";
import googlePlayBadge from "../assets/badges/google-play-badge.svg";

class AppCard extends Component {
  render() {
    const { app, logo, language } = this.props;

    return (
      <article className="card app-card">
        <div className="card-top">
          <div className="card-logo">
            <img src={logo} alt={`${app.name} logo`} className="app-logo" />
          </div>
          <div className="card-title">
            <span className="chip">
              {(app.category && app.category[language]) || app.category}
            </span>
            {app.detailPath ? (
              <a href={app.detailPath} className="app-title-link">
                <h3>{app.name}</h3>
              </a>
            ) : (
              <h3>{app.name}</h3>
            )}
            <span className="platform">{app.platform}</span>
          </div>
        </div>
        <p>{(app.description && app.description[language]) || app.description}</p>
        <div className="card-bottom">
          <span className="tag">{(app.tag && app.tag[language]) || app.tag}</span>
          <div className="store-badges">
            {app.appStoreUrl && (
              <a
                className="store-badge"
                href={app.appStoreUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={appleStoreBadge} alt="App Store" />
              </a>
            )}
            {app.googlePlayUrl && (
              <a
                className="store-badge"
                href={app.googlePlayUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayBadge} alt="Google Play" />
              </a>
            )}
          </div>
        </div>
      </article>
    );
  }
}

class AppsSectionMultiple extends Component {
  render() {
    const { apps, language, t } = this.props;

    if (!apps || apps.length < 2) {
      return null;
    }

    return (
      <section className="section apps-section apps-section-multiple" id="apps">
        <div className="section-head">
          <h2>{t("sections.publishedMultipleTitle")}</h2>
          <p>{t("sections.publishedMultipleDesc")}</p>
        </div>
        <div className="cards">
          {apps.map((app, index) => (
            <AppCard
              key={app.name}
              app={app}
              logo={app.logoPath}
              language={language}
            />
          ))}
        </div>
      </section>
    );
  }
}

export default AppsSectionMultiple;
